import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';

import React, { useState } from 'react';
import { useEffect } from 'react';
import Looading from './../../Shared/Looading/Looading';
import { useNavigate } from 'react-router-dom';


const Cheackout = ({ booking }) => {

    const { price, patient, email, _id } = booking;
    const stripe = useStripe();
    const elements = useElements();
    const [success, setSuccess] = useState('');
    const [cardError, setCardError] = useState('');
    const [transectionId, setTransectionId] = useState('');
    const [clientSecret, setClientSecret] = useState("");
    const [looading, setLooading] = useState(false);
    const [processing, setProcessing] = useState(false);

    const navigate = useNavigate();




    useEffect(() => {

        fetch("https://denticare-server-sumonhasan55.vercel.app/create-payment-intent", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                authorization: `bearer ${localStorage.getItem('accessToken')}`
            },

            body: JSON.stringify({ price }),
        })
            .then((res) => res.json())
            .then((data) => setClientSecret(data.clientSecret));
        console.log(clientSecret)
    }, [price]);

    if (looading) {

        setLooading(true)
    }


    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!stripe || !elements) {
            return;
        }
        const card = elements.getElement(CardElement);
        if (card == null) {
            return;
        }

        const { cardError, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card,
        });

        if (cardError) {
            console.log('[error]', error);
            setCardError(error.message)
        } else {
            //console.log('[PaymentMethod]', paymentMethod);
        }
        setSuccess('');
        setProcessing(true)

        const { paymentIntent, error } = await stripe.confirmCardPayment(
            clientSecret,
            {
                payment_method: {
                    card: card,
                    billing_details: {
                        name: patient,
                        email: email
                    },
                },
            },
        );
        if (error) {
            setCardError(error.message)

        }
        if (paymentIntent.status === 'succeeded') {

            console.log('paymentIntent', paymentIntent);
            const payment = {

                price,
                email,
                transectionId: paymentIntent.id,
                bookingId: _id

            }
            fetch('https://denticare-server-sumonhasan55.vercel.app/payments', {
                method: "POST",
                headers: {
                    'content-type': "application/json",
                    authorization: `bearer ${localStorage.getItem('accessToken')}`
                },
                body: JSON.stringify(payment)
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    if (data.insertedId) {
                        setSuccess('Congrats! your payment completed');
                        setTransectionId(paymentIntent.id);

                    }
                })



        }
        setProcessing(false)


    };



    return (
        <div>
            <form onSubmit={handleSubmit}>
                <CardElement
                    options={{
                        style: {
                            base: {
                                fontSize: '16px',
                                color: '#424770',
                                '::placeholder': {
                                    color: '#aab7c4',
                                },
                            },
                            invalid: {
                                color: '#9e2146',
                            },
                        },
                    }}
                />
                <button className='btn btn-info text-red-500 px-5 hover:bg-slate-100 btn-sm my-5 p-2 ' type="submit"
                    disabled={!stripe || !clientSecret || processing}>
                    Pay
                </button>
            </form>
            <p className='text-red-500'>{cardError}</p>
            {
                success && <div className="">
                    <p className='text-green-500 text-3xl '>{success}</p>
                    <p>Your transectionId:{transectionId}</p>
                    navigate('/dashboard')



                </div>

            }

        </div>
    );
};

export default Cheackout;